import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { getToken, isLoggedIn } from '../utils/tokenUtils';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Image from '@tiptap/extension-image';
import Underline from '@tiptap/extension-underline';
import styles from './BoardWritePage.module.css';

function RichEditor({ value, onChange }) {
    const editor = useEditor({
        extensions: [StarterKit, Underline, Image],
        content: value,
        onUpdate: ({ editor }) => onChange(editor.getHTML())
    });

    const uploadImage = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('imageFile', file);
        try {
            const res = await fetch('http://localhost:8080/api/products/editor-image', {
                method: 'POST',
                body: formData,
                headers: { Authorization: `Bearer ${getToken()}` }
            });
            const data = await res.json();
            editor.chain().focus().setImage({ src: `http://localhost:8080${data.imageUrl}` }).run();
        } catch {
            alert('이미지 업로드 실패.');
        }
    };

    if (!editor) return null;

    return (
        <div style={{ border: '1px solid #ddd', borderRadius: '6px', overflow: 'hidden' }}>
            <div style={{ display: 'flex', gap: '4px', padding: '8px', borderBottom: '1px solid #eee', flexWrap: 'wrap', background: '#f9f9f9' }}>
                <button type="button" onClick={() => editor.chain().focus().toggleBold().run()}
                    style={{ padding: '4px 8px', fontWeight: 'bold', background: editor.isActive('bold') ? '#000' : 'white', color: editor.isActive('bold') ? 'white' : '#333', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer' }}>B</button>
                <button type="button" onClick={() => editor.chain().focus().toggleItalic().run()}
                    style={{ padding: '4px 8px', fontStyle: 'italic', background: editor.isActive('italic') ? '#000' : 'white', color: editor.isActive('italic') ? 'white' : '#333', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer' }}>I</button>
                <button type="button" onClick={() => editor.chain().focus().toggleUnderline().run()}
                    style={{ padding: '4px 8px', textDecoration: 'underline', background: editor.isActive('underline') ? '#000' : 'white', color: editor.isActive('underline') ? 'white' : '#333', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer' }}>U</button>
                <button type="button" onClick={() => editor.chain().focus().toggleBulletList().run()}
                    style={{ padding: '4px 8px', background: editor.isActive('bulletList') ? '#000' : 'white', color: editor.isActive('bulletList') ? 'white' : '#333', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer' }}>• 목록</button>
                <label style={{ padding: '4px 8px', background: 'white', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' }}>
                    이미지
                    <input type="file" accept="image/*" onChange={uploadImage} style={{ display: 'none' }} />
                </label>
            </div>
            <EditorContent editor={editor} style={{ minHeight: '200px', padding: '12px' }} />
        </div>
    );
}

function BoardEditPage() {
    const { boardId } = useParams();
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [category, setCategory] = useState('GENERAL');
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoggedIn()) {
            navigate('/login');
            return;
        }
        axios.get(`http://localhost:8080/api/boards/${boardId}`)
            .then(res => {
                setTitle(res.data.title);
                setContent(res.data.content);
                setCategory(res.data.category);
            })
            .catch(console.error);
    }, [boardId]);

    const handleSubmit = async () => {
        if (!title.trim() || !content.trim()) {
            alert('제목과 내용을 입력해 주십시오.');
            return;
        }
        try {
            const formData = new FormData();
            formData.append('title', title);
            formData.append('content', content);

            await axios.patch(`http://localhost:8080/api/boards/${boardId}`, formData, {
                headers: { Authorization: `Bearer ${getToken()}` }
            });
            navigate(`/boards/${boardId}`);
        } catch (err) {
            console.error(err);
            alert('수정 실패.');
        }
    };

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>글 수정</h2>

            <div className={styles.formRow}>
                <label>분류</label>
                <select value={category} onChange={e => setCategory(e.target.value)}
                    className={styles.select}>
                    <option value="GENERAL">자유</option>
                    <option value="NOTICE">공지</option>
                    <option value="EVENT">이벤트</option>
                </select>
            </div>

            <div className={styles.formRow}>
                <label>제목</label>
                <input value={title} onChange={e => setTitle(e.target.value)}
                    placeholder="제목 입력" className={styles.input} />
            </div>

            <div className={styles.formRow}>
                <label>내용</label>
                {content !== '' && <RichEditor value={content} onChange={setContent} />}
            </div>

            <div className={styles.btnRow}>
                <button onClick={() => navigate(`/boards/${boardId}`)} className={styles.cancelBtn}>취소</button>
                <button onClick={handleSubmit} className={styles.submitBtn}>수정 완료</button>
            </div>
        </div>
    );
}

export default BoardEditPage;